import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SeoService {
	private readonly _canonicalLinkElement$ = new BehaviorSubject<HTMLLinkElement>(null);

	protected constructor(@Inject(DOCUMENT) private document: Document, private meta: Meta) {}

	get canonicalLinkElement$(): Observable<HTMLLinkElement> {
		return this._canonicalLinkElement$.asObservable();
	}

	getCanonicalLinkELement(): HTMLLinkElement {
		return this._canonicalLinkElement$.getValue();
	}

	setCanonicalLinkElement(linkElement: HTMLLinkElement): void {
		this._canonicalLinkElement$.next(linkElement);
	}

	/**
	 * Add the Robots meta tag
	 *
	 *  Add this to the page that is not intended to be indexed in Google search
	 */
	addRobotsMetaTag(): void {
		this.meta.addTag({ name: 'robots', content: 'noindex,nofollow' });
	}

	/**
	 * Remove the Robots meta tag
	 */
	removeRobotsMetaTag(): void {
		this.meta.removeTag("name='robots'");
	}

	/**
	 * Remove canonical link element
	 */
	removeCanonicalLinkElement(): void {
		const linkElement = this.getCanonicalLinkELement();

		if (linkElement) {
			linkElement.parentNode?.removeChild(linkElement);
			this.setCanonicalLinkElement(null);
		}
	}

	/**
	 * Create canonical URL
	 *
	 * @param url Canonical URL
	 * @returns HTML link element appended in the head tag
	 */
	createCanonicalLinkElement(url: string): HTMLLinkElement {
		const linkElement: HTMLLinkElement = this.document.createElement('link');

		linkElement.setAttribute('rel', 'canonical');
		this.document.head.appendChild(linkElement);
		linkElement.setAttribute('href', `https://kurdshopping.com${url}`);

		this.setCanonicalLinkElement(linkElement);

		return linkElement;
	}
}
